module.exports = __webpack_public_path__ + "static/media/secietypic01.fac34a56.png";